import {createApp} from 'vue';
import queryString from "query-string";
import axios from "axios";
import formsMixin from "@/formsMixin";

let contactFormElements = document.getElementsByClassName('ContactForm');

if (contactFormElements.length > 0) {
    for (let i = 0; i < contactFormElements.length; i++) {
        let elementID = contactFormElements[i].id;
        createApp({
            data() {
                return {
                    messageSent: false,
                    phoneNumber: '',
                    company: '',
                    whereDidYouHearAboutUs: '',
                    message: '',
                }
            },
            mixins: [formsMixin],
            computed: {
                canSendSignup() {
                    if (this.loading === true) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.email) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.fname) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.lname) === false) {
                        return false;
                    }
                    if (this.notUndefinedNullOrBlankString(this.message) === false) {
                        return false;
                    }
                    if (this.emailIsValid === false) {
                        return false;
                    }
                    if (this.recaptchaVerified !== true) {
                        return false;
                    }

                    return true;
                },
                messageClass() {
                    if (this.validationHasRun === true) {
                        if (this.message === '' || this.message === undefined) {
                            return 'is-invalid';
                        } else {
                            return 'is-valid';
                        }
                    }

                    return '';
                },
            },
            methods: {
                async sendSignup() {

                    this.validationHasRun = true;

                    await this.recaptchaVerify();

                    if (this.canSendSignup === true) {

                        this.loading = true;
                        this.apiError = false;

                        let urlParams = {
                            email: this.email,
                            fname: this.fname,
                            lname: this.lname,
                            phone: this.phoneNumber,
                            message: this.message,
                            company: this.company,
                            whereDidYouHearAboutUs: this.whereDidYouHearAboutUs,
                        };

                        let url = '/api/contactformsubmission?' + queryString.stringify(urlParams);

                        try {
                            await axios.get(
                                url,
                                {
                                    headers: {
                                        'content-type': 'application/x-www-form-urlencoded'
                                    }
                                }
                            ).then((response) => {
                                let data = response.data;
                                if (data.status === 'failed') {
                                    this.apiError = true;
                                } else {
                                    this.messageSent = data.messageSent;
                                    Toastify({
                                        text: "Your message has been sent",
                                    }).showToast();
                                }
                                this.loading = false;
                            });

                        } catch (err) {
                            if (err.response) {
                                // The client was given an error response (5xx, 4xx)
                                console.log('The client was given an error response (5xx, 4xx)');
                            } else if (err.request) {
                                // The client never received a response, and the request was never left
                                console.log('The client never received a response, and the request was never left');
                            } else {
                                // Anything else
                                console.log('Other error');
                            }
                            this.loading = false;
                            this.apiError = true;
                        }
                    }
                }
            }
        }).mount('#' + elementID);
    }
}